module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__configure-system--section",
    attrs: {
      "sticky-container": ""
    }
  }, [_c('div', {
    staticClass: "system-builder__system-container"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky"
    }],
    attrs: {
      "sticky-offset": "offset",
      "sticky-side": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "/live/wp-content/themes/compustar/images/module-family.png",
      "alt": "Compustar systems family"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-container--content"
  }, [_c('div', {
    staticClass: "system-builder__configure-system--vehicle-container"
  }, [_c('h3', [_vm._v("1) Enter Your Vehicle")]), _vm._v(" "), _c('p', [_vm._v("What is your vehicle's year, make and model?")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.sharedState.vehicleMakesData.length < 1) ? _c('div', [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading Vehicle list..."
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedMake),
      expression: "sharedState.selectedMake"
    }],
    ref: "makesSelection",
    attrs: {
      "id": "vehicle-make",
      "name": "vehicle-make"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedMake = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleModels]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedMake
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedMake))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleMakesData), function(make) {
    return _c('option', {
      domProps: {
        "value": make
      }
    }, [_vm._v(_vm._s(make))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedModel),
      expression: "sharedState.selectedModel"
    }],
    attrs: {
      "id": "vehicle-model",
      "name": "vehicle-model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getVehicleYears]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedModel
    }
  }, [_vm._v(_vm._s(_vm.sharedState.selectedModel))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleModelsData), function(model) {
    return _c('option', {
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "select-button-style"
  }, [_c('div', {
    staticClass: "arrow-button"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sharedState.selectedYear),
      expression: "sharedState.selectedYear"
    }],
    attrs: {
      "id": "vehicle-year",
      "name": "vehicle-year",
      "data-id": _vm.sharedState.selectedYear
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sharedState.selectedYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateVehicleObjectState]
    }
  }, [_c('option', {
    attrs: {
      "data-year": _vm.sharedState.selectedYearValue,
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.sharedState.selectedYear
    }
  }, [_vm._v(_vm._s(_vm.sharedState.vehicleObject.year))]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("_____________")]), _vm._v(" "), _vm._l((_vm.sharedState.vehicleYearsData), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.year))])
  })], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-container"
  }, [_c('h3', [_vm._v("2) Choose Your System")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.categoryModal = true
      }
    }
  }, [_vm._v("Which system is right for you?")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.remoteStart
    },
    attrs: {
      "id": "remoteStart"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to remote start my car.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.security
    },
    attrs: {
      "id": "security"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to secure my car.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--system-option",
    class: {
      'system-builder__configure-system--system-option-selected': _vm.sharedState.remoteStartSecurity
    },
    attrs: {
      "id": "remoteStartSecurity"
    },
    on: {
      "click": _vm.setSelectedCategory
    }
  }, [_vm._v("\n          I want to remote start & secure my car.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__configure-system--upgrade-container"
  }, [_c('h3', [_vm._v("3) Optional System Upgrades")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.upgradeModal = true
      }
    }
  }, [_vm._v("Which upgrades are right for you?")]), _vm._v(" "), _vm._l((_vm.options), function(currentOption) {
    return _c('div', {
      key: currentOption.id,
      staticClass: "system-builder__configure-system--upgrade-option",
      class: {
        'system-builder__configure-system--upgrade-option-selected': _vm.checkIfAttributeSelected(currentOption.id)
      },
      attrs: {
        "id": currentOption.id,
        "selected": currentOption.selected,
        "locked": currentOption.locked
      },
      on: {
        "click": _vm.updateSelectedAttribute
      }
    }, [_vm._v("\n          " + _vm._s(currentOption.name) + "\n\n          "), (currentOption.locked) ? _c('notification', {
      attrs: {
        "name": "lockedMessage",
        "nColor": "rgba(226, 144, 37, 0.85)",
        "isActive": _vm.lockedMessage
      },
      on: {
        "closeNotification": function($event) {
          _vm.lockedMessage = false
        }
      }
    }, [_c('div', {
      slot: "notification-body"
    }, [_vm._v("\n              " + _vm._s(currentOption.lockedMessage) + "\n            ")])]) : _vm._e()], 1)
  })], 2)])]), _vm._v(" "), _c('footerNav'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "categoryInfoModal",
      "isActive": _vm.categoryModal
    },
    on: {
      "closeModal": function($event) {
        _vm.categoryModal = false
      }
    }
  }, [_c('div', {
    slot: "modal-body"
  })]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "upgradeInfoModal",
      "isActive": _vm.upgradeModal
    },
    on: {
      "closeModal": function($event) {
        _vm.upgradeModal = false
      }
    }
  }, [_c('div', {
    slot: "modal-body"
  }, _vm._l((_vm.sharedState.accessories), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__modal--item"
    }, [_c('div', {
      staticClass: "system-builder__modal--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images[0].image.url,
        "alt": upgrade.images[0].image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__modal--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(upgrade.description)
      }
    })])])
  }))]), _vm._v(" "), _c('notification', {
    attrs: {
      "name": "successNotification",
      "nColor": "#78bf5e",
      "isActive": _vm.successNotification
    },
    on: {
      "closeNotification": function($event) {
        _vm.successNotification = false
      }
    }
  }, [_c('div', {
    slot: "notification-body"
  }, [_vm._v("\n      Your vehicle is compatible!\n    ")])]), _vm._v(" "), _c('notification', {
    attrs: {
      "name": "warningNotification",
      "nColor": "#d25b4b",
      "isActive": _vm.warningNotification
    },
    on: {
      "closeNotification": function($event) {
        _vm.warningNotification = false
      }
    }
  }, [_c('div', {
    slot: "notification-body"
  }, [_vm._v("\n      Please check with a dealer near you for vehicle compatibility.\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Build Your System")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-792cec73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/ConfigureSystem.vue
// module id = 427
// module chunks = 1